module.exports = __webpack_public_path__ + "static/media/participantStamp.2c4c3585.svg";